import { createApp, watch, nextTick } from "vue";
import { store, mutations } from "@js/vue/store";
import { registerComponents } from "@js/vue/components";
import { registerDirectives } from "@js/vue/directives";

export function initializeApp() {
	/*
	 * Create the app
	 */
	const app = createApp({
		delimiters: ["${", "}"],
		setup() {
			return { store, mutations };
		},
	});

	app.config.errorHandler = (err, instance, info) => {
		console.error("Error:", err);
		console.log("Vue component:", instance);
		console.log("Additional info:", info);
	};

	// Watch for nav changes and update CSS custom properties
	// Use batch updates for better performance
	const documentElement = document.documentElement;

	watch(() => store.navDropdownHeight, (newHeight) => {
		requestAnimationFrame(() => {
			documentElement.style.setProperty('--nav-dropdown-height', `${newHeight}px`);
		});
	}, { immediate: true });

	watch(() => store.navDrawerWidth, (newWidth) => {
		requestAnimationFrame(() => {
			documentElement.style.setProperty('--nav-drawer-width', `${newWidth}px`);
		});
	}, { immediate: true });

	// Register all components
	registerComponents(app);

	// Register all directives
	registerDirectives(app);

	/*
	 * Mount the app
	 */
	app.mount("#app");
}
